export enum SaveDataKeys {
    lastSolvedLevel = 'lastSolvedLevel',
    testerEvents = 'testerEvents',
    inventory = 'inventory',
    livesRegenTimeStamp = 'livesRegenTimeStamp',
    settingsSFX = 'settingsSFX',
    settingsMusic = 'settingsMusic',
    settingsVibrate = 'settingsVibrate',
    FTUEProgressData = 'FTUEProgressData',
    levelsInSession = 'levelsInSession',
    sessionDuration = 'sessionDuration',
    retryTutorialPassed = 'retryTutorialPassed',
    lastDailyReward = 'lastDailyReward',
    totalPlayTime = 'totalPlayTime',
    numberOfSessions = 'numberOfSessions',
    chapterScore_ = 'chapterScore_',
    type = 'type',
    solved = 'solved',
}

export enum SaveDataKeysDefaults {
    lastSolvedLevel = 0,
    testerEvents = 'testerEvents',
    inventory = 'inventory',
    livesRegenTimeStamp = 'livesRegenTimeStamp',
    settingsSFX = 'On',
    settingsMusic = 'On',
    settingsVibrate = 'On',
    retryTutorialPassed = 'false',
    lastDailyReward = 'lastDailyReward',
    totalPlayTime = 'totalPlayTime',
    numberOfSessions = 0,
    type = 'type',
    solved = 0,
}